<template>
  <div>
    <button
      type="button"
      v-if="!!bookingUuid"
      :class='[
        "btn",
        "btn-outline-primary",
        "d-flex",
      ]'
      @click.prevent="showBooking">
      <span>
        <i class="fa fa-calendar-check-o" aria-hidden="true"></i>
      </span>
      <span class="d-none d-sm-inline mx-1">
        {{ $t("Booking") }}
      </span>
      <span v-if="bookingUuid">
        <span class="d-none d-sm-inline badge badge-primary">1</span>
      </span>
    </button>
    <Modal
      :title="$t('Booking information')"
      :show="showModal"
      @hidePrevented="showModal = false"
      @hide="showModal = false"
    >
      <BookingInformation
        v-if="booking"
        :booking="booking"
        class="my-2"
      ></BookingInformation>
      <template #footer v-if="booking">
        <div class="modal-footer justify-content-between flex-column">
          <RemainingTime :booking="booking" class="w-100 mb-2"></RemainingTime>
          <div class="d-flex justify-content-between w-100">
            <BookingCancellation
              :booking="booking"
              :urlBooking="urlBooking"
              @canceled="onCanceledBooking"
            ></BookingCancellation>
            <a class="btn btn-primary ml-2"
               :href="urlRegistration">
              {{ $t('Continue to registration') }}
            </a>
          </div>
        </div>
      </template>
    </Modal>
  </div>

</template>

<script setup>
import { ref } from "vue";
import Modal from "@/components/frontend/ui/Modal.vue";
import BookingInformation from "@/components/frontend/booking/BookingInformation.vue";
import BookingCancellation from "@/components/frontend/booking/BookingCancellation.vue";
import RemainingTime from "@/components/frontend/booking/RemainingTime.vue";
import useBookingSession from "@/components/frontend/composable/useBookingSession.ts";

const { bookingUuid, removeBooking } = useBookingSession();


const props = defineProps({
  urlBooking: {
    type: String,
    required: true
  },
  urlRegistration: {
    type: String,
    required: true
  },
})

const showModal = ref(false);
const booking = ref(null);

const showBooking = async () => {
  if (! bookingUuid.value) {
    return
  }

  showModal.value = true
  try {
    const {data} = await axios.get(`${props.urlBooking}/${bookingUuid.value}`)
    booking.value = data.data;
  } catch (error) {
    booking.value = null
    removeBooking();
  }
}

const onCanceledBooking = () => {
  showModal.value = false
  booking.value = null
  removeBooking();
  window.location.reload()
};
</script>